import { render } from "./BaseButton.vue?vue&type=template&id=39d2417c&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=39d2417c&scoped=true&lang=css"

import exportComponent from "C:\\8 Extension Folder\\8.0 Extension Folder\\8.02\\SMMPortfolioSite\\photographydays-login\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d2417c"]])

export default __exports__